import * as React from 'react'

import { Button, Skeleton } from '@factorialco/deprecated-design-system'

import FormRow from 'modules/core/components/FormRow'
import DayPicker from 'modules/core/components/Inputs/DayPicker'
import Select from 'modules/core/components/Inputs/Select'
import Text from 'modules/core/components/Inputs/Text'
import TextArea from 'modules/core/components/Inputs/TextArea'
import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { useGoal } from 'modules/goals/hooks/useGoal'
import { TYPES } from 'modules/goals/store/models/GoalConfig'

export const EditGoalModal: React.FC<{ id: string; onClose: () => void }> = ({ id, onClose }) => {
  const { loading, goalConfig, form } = useGoal(Number(id))
  const [disabled, setDisabled] = React.useState(false)

  const onSubmit = () => {
    if (goalConfig) {
      form.save(goalConfig)
      onClose()
    }
  }

  const options = [
    {
      value: TYPES.numeric,
      label: i18n.t('surveys.goals.types.numeric'),
    },
    {
      value: TYPES.none,
      label: i18n.t('surveys.goals.types.none'),
    },
  ]

  const checkContent = (value: string) => {
    setDisabled(!value)
  }

  return (
    <Modal
      illustration="browser-edit"
      title={i18n.t('surveys.goals.edit.title')}
      description={i18n.t('surveys.goals.edit.description')}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={disabled} submit>
            {i18n.t('surveys.goals.edit.update')}
          </Button>
        </>
      }
    >
      {loading ? (
        <Skeleton isLoading height="s300" />
      ) : (
        <>
          <FormRow>
            <Text
              label={i18n.t('surveys.goals.new.goal_name')}
              field={form.get('name')}
              mandatory
              onChange={() => checkContent(form.get('name').value)}
            />
          </FormRow>
          <FormRow>
            <TextArea
              label={i18n.t('surveys.goals.new.goal_description')}
              field={form.get('description')}
            />
          </FormRow>
          <FormRow multi>
            <DayPicker
              label={i18n.t('surveys.goals.common.start_date')}
              field={form.get('start_date')}
            />
            <DayPicker
              label={i18n.t('surveys.goals.common.due_date')}
              field={form.get('due_date')}
            />
          </FormRow>
          <FormRow>
            <Select
              label={i18n.t('surveys.goals.new.type')}
              field={form.get('goal_type')}
              options={options}
              showOriginalLabelText
              readonly
            />
          </FormRow>
        </>
      )}
    </Modal>
  )
}
